<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { capFirstChar } from '../../../helpers/utilities';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Collapse } from '@Shelly/shelly-design-system';
	//Components
	import PlusUniCounterInputName from './PlusUniCounterInputName.svelte';
	import InputThresholdAndFrequency from './InputThresholdAndFrequency.svelte';
	import CustomExpresionPlusUni from './CustomExpresionPlusUni.svelte';
	import WebHooksG2 from '../WebHooks/WebHooksG2/WebHooksG2.svelte';
	import EnableInputCounter from './EnableInputCounter.svelte';
	import ResetCounters from './ResetCounters.svelte';
	//Types
	import type { Device } from '../../../types/Device';

	export let device: Device;

	const settings = devices_settings.getByRealId(device.id),
		collapseSubMenu: any = [
			{
				component: PlusUniCounterInputName,
				title: $format('sub_settings_title_input_name', {
					default: 'Input name',
				}),
				props: {
					device,
					settings,
				},
				expanded: false,
			},
			{
				component: EnableInputCounter,
				title: $format('sub_settings_title_enable_input', {
					default: 'Enable input',
				}),
				props: {
					device,
				},
				expanded: false,
			},
			{
				component: InputThresholdAndFrequency,
				title: $format('sub_settings_title_counter_input_threshold', {
					default: 'Report Threshold',
				}),
				props: {
					device,
					settings,
					thrMin: 1,
					thrMax: 2147483647,
					unit: 'pulses',
					settingType: 'count_rep_thr',
				},
				expanded: false,
			},
			{
				component: InputThresholdAndFrequency,
				title: $format('sub_settings_title_input_counter_frequency_window', {
					default: 'Frequency Window',
				}),
				props: {
					device,
					settings,
					thrMin: 1,
					thrMax: 3600,
					unit: 'seconds',
					settingType: 'freq_window',
				},
				expanded: false,
			},
			{
				component: InputThresholdAndFrequency,
				title: $format('sub_settings_title_input_counter_frequency_report_threshold', {
					default: 'Frequency Report Threshold',
				}),
				props: {
					device,
					settings,
					thrMin: 0,
					thrMax: 10000,
					unit: '%',
					settingType: 'freq_rep_thr',
				},
				expanded: false,
			},
			{
				component: CustomExpresionPlusUni,
				title: $format('sub_settings_title_input_counter_custom_expression_counts', {
					default: 'Counts Custom Expression',
				}),
				props: {
					device,
					settings,
					settingType: 'xcounts',
				},
				expanded: false,
			},
			{
				component: CustomExpresionPlusUni,
				title: $format('sub_settings_title_input_counter_custom_expression_frequency', {
					default: 'Frequency Custom Expression',
				}),
				props: {
					device,
					settings,
					settingType: 'xfreq',
				},
				expanded: false,
			},
			{
				component: ResetCounters,
				title: $format('sub_settings_title_input_counter_reset', {
					default: 'Reset Counters',
				}),
				props: { device, settings },
				expanded: false,
			},
			{
				component: WebHooksG2,
				title: $format('sub_settings_title_addon_actions_settings', {
					default: 'Actions',
				}),
				props: { device, plusUniWebHook: true },
				expanded: false,
			},
		];
</script>

{#each collapseSubMenu as { title, component, props, expanded }}
	<Collapse
		id="collapse-qk8uglr"
		title={capFirstChar(title)}
		class="mb-s"
		{expanded}
		on:click={() => {
			if (expanded) {
				expanded = false;
			} else {
				collapseSubMenu.forEach((i) => {
					i.expanded = false;
				});
				expanded = true;
			}
		}}
	>
		<svelte:component this={component} {...props} />
	</Collapse>
{/each}
